import React from 'react';
import PropTypes from 'prop-types';

import LeftBlockWrapper from 'styled/Editor/LeftBlockWrapper';

import Container from 'styled/Editor/Container';
import SubBlock from 'styled/Editor/SubBlock';
import FormLabel from 'styled/Editor/FormLabel';

import Length from './Length';
import TextareaStyled from './TextareaStyled';
import TextareaWrapper from './TextareaWrapper';

const TITLE_MAX_LENGTH = 80;
const DESCRIPTION_MAX_LENGTH = 300;
const DESCRIPTION_MAX_LENGTH_LIMIT = 500;

class PublicationShareBlock extends React.PureComponent {
  render() {
    return (
      <Container>
        <LeftBlockWrapper style={{ display: 'flex', flexDirection: 'column' }}>
          <FormLabel style={{ marginBottom: '20px' }}>
            Представление при шеринге
          </FormLabel>

          <TextareaWrapper>
            <TextareaStyled
              value={this.props.shareTitle}
              maxLength={TITLE_MAX_LENGTH}
              placeholder="Добавьте заголовок"
              onChange={this.props.onShareTitleChange}
            />

            <Length>
              {this.props.shareTitle ? this.props.shareTitle.length : '0'}/
              {TITLE_MAX_LENGTH}
            </Length>
          </TextareaWrapper>

          <TextareaWrapper>
            <TextareaStyled
              value={this.props.shareDescription}
              maxLength={DESCRIPTION_MAX_LENGTH_LIMIT}
              placeholder="Добавьте описание"
              onChange={this.props.onShareDescriptionChange}
            />

            <Length>
              {this.props.shareDescription
                ? this.props.shareDescription.length
                : '0'}
              /{DESCRIPTION_MAX_LENGTH}
            </Length>
          </TextareaWrapper>
        </LeftBlockWrapper>

        <SubBlock />
      </Container>
    );
  }
}

PublicationShareBlock.propTypes = {
  shareTitle: PropTypes.string,
  shareDescription: PropTypes.string,

  onShareTitleChange: PropTypes.func,
  onShareDescriptionChange: PropTypes.func,
};

PublicationShareBlock.defaultProps = {
  shareTitle: '',
  shareDescription: '',

  onShareTitleChange: () => {},
  onShareDescriptionChange: () => {},
};

export default PublicationShareBlock;
